import React from "react";
import {
  Box,
  Button,
  Paper,
  Typography,
} from "components/mui";
import HtmlEditor from "../HtmlEditor";
import DropEditor from "../DropEditor";

/**
 * The body editor area: the "Body" label, the Reset button, and the two editor panes.
 *
 * Both panes stay mounted and are swapped with `display` so switching editors doesn't
 * destroy in-progress content. The Drop pane is not rendered at all below the
 * Drop-editor width, so Unlayer's iframe is never created on devices that can't use it.
 *
 * @param body - the `useEmailBody` result.
 */
function EditorPane({ body, onReset }) {
  return (
    // Plain Box: this sits directly in the page, not inside a <Grid container>, so a
    // `Grid item` here was invalid MUI usage (Bug #7).
    <Box sx={{ pt: 2 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {/* `variant="body"` is not a real MUI variant; body1 is the intended default. */}
        <Typography variant="body1" color="text.secondary">
          Body
        </Typography>
        <Button
          variant="outlined"
          size="small"
          sx={{ borderColor: "grey.500", color: "grey.500", mb: 2 }}
          onClick={onReset}
        >
          Reset
        </Button>
      </Box>

      {body.canUseDropEditor && (
        <Box sx={{ display: body.isDropEditor ? "block" : "none", mb: 3 }}>
          <DropEditor
            key={body.dropEditorKey}
            onChange={body.setDropHtml}
            onJsonChange={body.setDropDesignJson}
            designToLoad={body.dropDesignToLoad}
            editorRef={body.editorRef}
          />
        </Box>
      )}

      <Box sx={{ display: body.isDropEditor ? "none" : "block", mb: { xs: 16, sm: 3 } }}>
        <Paper
          elevation={2}
          sx={{
            p: 2,
            borderRadius: 2,
          }}
        >
          <HtmlEditor value={body.textContent} onChange={body.setTextContent} />
        </Paper>
      </Box>
    </Box>
  );
}

export default EditorPane;
